import { Component, OnInit } from '@angular/core';
import { PenService } from './pen.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../services/loader.service';
import { StorageService } from '../../../services/storage.service';
import { SubscriptionService } from '../../../services/subscription.service';

@Component({
  selector: 'app-pen',
  templateUrl: './pen.component.html',
  styleUrls: ['./pen.component.scss'],
})
export class PenComponent {
  isModalOpen = false;
  domain: string = '';
  errMsg: string | null = null;
  userPen: any; // View Report
  async openModal() {

    let sub = await this.storageServive.getUserSubscription();
    if (!this.subscriptionService.hasActiveSubscription() || !(sub && sub.subscription_plan.features[0].quantity && sub.subscription_plan.features[0].quantity > this.pens.length)) {
      this.router.navigate(['/subscription']);
    }
    else {
      this.isModalOpen = true;
    }

  }

  viewReport(data: any) {
    this.userPen = data;
  }
  closeReport() {
    this.userPen = null;
  }
  closeModal() {
    this.domain = '';
    this.errMsg = '';
    this.isModalOpen = false;
  }
  getStatus(pen: any) {
    if (pen?.pen == null) {
      return pen?.error;
    }
    if (pen?.pen?.valid_to)
      return new Date(pen?.pen?.valid_to) > new Date() ? 'Active' : 'Inactive';
    return 'Unknown';
  }
  pens: any[] = [];
  noPensMessage: string = 'No pen tests available. Please add a new domain.';
  filteredPens = [...this.pens];
  newDomain = '';
  searchQuery: string = '';

  constructor(
    private penService: PenService,
    private router: Router,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private storageServive: StorageService,
    private subscriptionService: SubscriptionService,
  ) { }

  ngOnInit(): void {
    this.fetchPens();

    // check query params when component loads
    this.route.queryParams.subscribe((params) => {
      const domainFromUrl = params['domain'];
      if (domainFromUrl) {
        this.openReportIfExists(domainFromUrl);
      }
    });

    this.pollingForPenTest();
  }
  pollingForPenTest() {
    setInterval(() => {
      this.fetchPens(true);
    }, 10000);
  }

  private openReportIfExists(domain: string) {
    // wait until pens are fetched
    if (this.pens.length > 0) {
      const matchedPen = this.pens.find(
        (pen) => pen.domain?.toLowerCase() === domain.toLowerCase()
      );
      console.log('Matched Pen: ', matchedPen);
      if (matchedPen && matchedPen.status === 'READY') {
        this.viewReport(matchedPen); // open modal with report
      } else {
        // if not found → just ensure we stay on /pen without modal
        this.router.navigate(['/pen']);
      }
    } else {
      // pens not yet loaded → check again after fetch
      const checkInterval = setInterval(() => {
        if (this.pens.length > 0) {
          clearInterval(checkInterval);
          this.openReportIfExists(domain);
        }
      }, 500);
    }
  }

  saveDomain() {
    // Regex pattern to validate domain
    const domainPattern = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    // Reset error message
    this.errMsg = '';

    // Check if the domain is valid
    if (domainPattern.test(this.domain)) {
      // Perform any API call or logic here
      this.upsertPenTest(this.domain);
    } else {
      this.errMsg = 'Please enter a valid domain';
    }
  }

  async retestPen(domain: string | null) {
    if (domain) {
      let sub = await this.storageServive.getUserSubscription();

      if (!this.subscriptionService.hasActiveSubscription() || !(sub && sub.subscription_plan.features[0].quantity && sub.subscription_plan.features[0].quantity > this.pens.length)) {
        this.router.navigate(['/subscription']);
      }
      else {
        this.upsertPenTest(domain);
      }


    }
  }

  upsertPenTest(domain: string) {
    this.loader.showLoader();
    this.penService.upsertPen(domain).subscribe({
      next: (response) => {
        console.log(
          'pen.component.ts [127ea4] upserPenTest subscribe next: ',
          response
        );
        this.fetchPens();
        this.closeModal();
        this.loader.hideLoader();
      },
      error: (error) => {
        console.log(
          'pen.component.ts [127ea4] upserPenTest subscribe error: ',
          error
        );
        this.loader.hideLoader();
      },
    });
  }

  navigateToChatComponent(): void {
    // check if subscription plan is present
    this.router.navigate(['/chat']);
  }

  onSearchChange(): void {
    const lowerCaseQuery = this.searchQuery.toLowerCase();

    this.filteredPens = this.pens.filter((pen) => {
      return pen.domain?.toLowerCase().includes(lowerCaseQuery);
    });
  }

  fetchPens(isPolling: boolean = false): void {
    if (!isPolling) {
      this.loader.showLoader();
    }
    this.penService.getAllPens().subscribe({
      next: (response) => {
        this.pens = response;
        // check if any entry with status PENDING has ch
        if (isPolling) {
          const pendingPens = this.pens.filter(
            (pen) =>
              pen.status === 'PENDING' && !pen.createdAt && !pen.updatedAt
          );
          if (pendingPens.length > 0) {
            this.filteredPens = [...this.pens];
          }
        } else {
          this.filteredPens = [...this.pens];
        }
        this.loader.hideLoader();
      },
      error: (error) => {
        console.error('Error fetching pens:', error);
        this.loader.hideLoader();
      },
    });
  }
}
